import React from "react";
import { CompleoListPage } from "customHooks/useList";

const ApplicantsReport = (props: any) => {
    const module = "REPORTSAPPLICANTS";

    return (
        <CompleoListPage
            moduleName={module}
            listApiAddress="/applicant/list"
        ></CompleoListPage>
    );
};

export default ApplicantsReport;
